/**
 * Mock execution utilities
 */

import { type MockData } from "./parser";

/**
 * Get mock data by ID
 */
export function getMockById(
  mocks: MockData[],
  id: string,
): MockData | undefined {
  return mocks.find((mock) => mock.id === id);
}
